import userStore from '../stores/user.store';
import appSettings from '../constants/settings.constants';

const fetchMode = { mode: 'cors' };

class FetchService {
    authenticatedGet = async url => {
        const headers = { 'Authorization': `Bearer ${ userStore.userToken }` };
        const request = new Request(`${ appSettings.apiUrl }${ url }`, {
            method: 'GET',
            headers: headers
        });

        return fetch(request, fetchMode).then((response) => {
                if (response) {
                    return (this.checkResponse(response));
                }
            }
        );
    };

    authenticatedPost = async (url, body) => {
        const headers = {
            'Authorization': `Bearer ${ userStore.userToken }`,
            'Content-Type': 'application/json'
        };
        const request = new Request(`${ appSettings.apiUrl }${ url }`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
        });

        return fetch(request, fetchMode).then((response) => {
                if (response) {
                    return (this.checkResponse(response));
                }
            }
        );
    };

    authenticatedDelete = async url => {
        const headers = { 'Authorization': `Bearer ${ userStore.userToken }` };
        const request = new Request(`${ appSettings.apiUrl }${ url }`, {
            method: 'DELETE',
            headers: headers
        });

        return fetch(request, fetchMode).then((response) => {
                if (response) {
                    return (this.checkResponse(response));
                }
            }
        );
    };

    authenticatedPut = async (url, body) => {
        const headers = {
            'Authorization': `Bearer ${ userStore.userToken }`,
            'Content-Type': 'application/json'
        };
        const request = new Request(`${ appSettings.apiUrl }${ url }`, {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(body)
        });

        return fetch(request, fetchMode).then((response) => {
                if (response) {
                    return (this.checkResponse(response));
                }
            }
        );
    };

    authenticatedPatch = async (url, body) => {
        const headers = {
            'Authorization': `Bearer ${ userStore.userToken }`,
            'Content-Type': 'application/json'
        };
        const request = new Request(`${ appSettings.apiUrl }${ url }`, {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(body)
        });

        return fetch(request, fetchMode).then((response) => {
                if (response) {
                    return (this.checkResponse(response));
                }
            }
        );
    };

    patch = async (url, body) => {
        const headers = {
            'Content-Type': 'application/json'
        };
        const request = new Request(`${ appSettings.apiUrl }${ url }`, {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(body)
        });

        return fetch(request, fetchMode).then((response) => {
                if (response) {
                    return (this.checkResponse(response));
                }
            }
        );
    };
    post = async (url, body) => {
        const headers = {
            'Content-Type': 'application/json'
        };
        const request = new Request(`${ appSettings.apiUrl }${ url }`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body)
        });

        return fetch(request, fetchMode).then((response) => {
                if (response) {
                    return (this.checkResponse(response));
                }
            }
        );
    };
    get = async url => {
        const headers = {
            'Content-Type': 'application/json'
        };
        const request = new Request(`${ appSettings.apiUrl }${ url }`, {
            method: 'GET',
            headers: headers
        });

        return fetch(request, fetchMode).then((response) => {
                if (response) {
                    return (this.checkResponse(response));
                }
            }
        );
    };

    checkResponse = async response => {
        let data;
        try {
            data = await response.json();
        } catch (error) {
            const responseError = new Error(
                `Request failed with status ${ response.status }`
            );
            responseError.status = response.status;
            throw responseError;
        }

        const apiError = data && data.data && data.data.isError;
        if (!response.ok || apiError) {
            const message = data?.data?.message || data?.error ||
                `Request failed with status ${ response.status }`;
            const error = new Error(message);
            error.status = response.status;
            error.response = data;
            throw error;
        }

        return data;
    };
}

const fetchService = new FetchService();
export default fetchService;
